export default "__VITE_ASSET__7rA8poAE__"